import { isBooleanSpec, isNumberSpec, isStringSpec } from '../../core';
export const filterPropertiesForObjectInline = (properties) => {
    return Object.fromEntries(Object.entries(properties).filter(([, propSpec]) => isStringSpec(propSpec) || isNumberSpec(propSpec) || isBooleanSpec(propSpec)));
};
